export default "__VITE_ASSET__ZYE_Zzz3__"